import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import styles from './overlay.module.css';
import ModalCloseButton from '../../components/UI/ModalCloseButton';
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Alert from '@material-ui/lab/Alert';
import { ReactComponent as Plus } from "../../utils/assets/plus.svg";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


// import { useNavigate } from 'react-router-dom';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, player, setPlayer, ...other } = props;

    const handleChange = (event) => {
        setPlayer(event.target.value);
    };

    return (
        <DialogTitle sx={{ m: 0, p: 1 }} {...other} style={{ backgroundColor: 'var(--primary-theme-color)' }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={player}
                    onChange={handleChange}
                    placeholder="Language"
                    style={{
                        backgroundColor: '#0F9BB0', color: '#ffffff'
                    }}
                >
                    <MenuItem value="">
                        <em>PickPlayer</em>
                    </MenuItem>
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                </Select>
            </FormControl>
            {onClose ? <ModalCloseButton onClick={onClose} /> : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function AddUser() {
    const axios = useAxiosPrivate()
    const [open, setOpen] = React.useState(false);
    const [player, setPlayer] = React.useState('');

    const initialValue =
        '<p>Take a note.....</p>';
    // let navigate = useNavigate();
    // eslint-disable-next-line
    const [value, onChange] = useState(initialValue);
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: 'success',
        message: '',
    });
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const addJuernal = async () => {
        try {
            await axios.post('/team/invite', {});
            setAlert({
                showAlert: true,
                severity: 'Success',
                message: 'Note Successfully added!',
            });
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'Success',
                    message: 'Note Successfully added!',
                });
                handleClose();
            }, 5000);
        } catch (e) {
            setAlert({
                showAlert: true,
                severity: 'error',
                message: 'Server error!',
            });
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'error',
                    message: 'Server error!',
                });
            }, 5000);
        }
    }


    return (
        <div>
            <div
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleClickOpen}
            >
                <Plus style={{ width: '0.8rem', height: '0.8rem' }} />
            </div>
            <BootstrapDialog
                maxWidth='sm'
                fullWidth='sm'
                onClose={handleClose}
                aria-labelledby='customized-dialog-title'
                open={open}
            >
                <BootstrapDialogTitle
                    id='customized-dialog-title'
                    onClose={handleClose}
                    player={player}
                    setPlayer={setPlayer}
                ></BootstrapDialogTitle>
                <DialogContent style={{ paddingTop: '1rem' }}>

                    {/* <RichText value={value} onChange={onChange}/> */}

                    {alert.showAlert && (
                        <div style={{ padding: '0.5rem 2rem' }}>
                            <Alert
                                severity={alert.severity}
                                onClose={() =>
                                    setAlert({
                                        ...alert,
                                        showAlert: false,
                                    })
                                }
                            >
                                {alert.message}
                            </Alert>
                        </div>
                    )}
                    <div style={{ backgroundColor: '' }}>
                        <input
                            type='button'
                            className={value !== '<p>Take a note.....</p>' ? styles.searchButton : styles.disabled}
                            value='Save'
                            onClick={addJuernal}
                        />
                    </div>

                </DialogContent>
            </BootstrapDialog>
        </div>
    );
}
